import React from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbars/AppNavbar.js";
import Footer from "../components/Footers/Footer.js";
import FooterSM from "../components/Footers/FooterSmall.js";
import Terms from "../components/Terms/index.js";
import Privacy from '../components/Privacy/index.js';
import Head from "next/head";
import Storyblok from "../lib/storyblok"
import { NextSeo, ProductJsonLd } from "next-seo";


export default function Sellers(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  return (
    <>
    <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <link  rel="canonical" href={`https://musicart.io/privacy-policy`} />
    </Head>

    
      {props.allcomponent && props.allcomponent.seo_metatags && (
       
        <>
        
          <NextSeo
            title={`${props.allcomponent.seo_metatags.title}`}
            description={props.allcomponent.seo_metatags.description}
            og_description={props.allcomponent.seo_metatags.og_description}
            og_image={props.allcomponent.seo_metatags.og_image}
            og_title={props.allcomponent.seo_metatags.og_title}
            twitter_description={props.allcomponent.seo_metatags.twitter_description}
            twitter_image={props.allcomponent.seo_metatags.twitter_image}
            twitter_title={props.allcomponent.seo_metatags.twitter_title}
          />

        </>
      )} 
        
      <Navbar transparent />
      <Privacy privacy={props.privacy && props.privacy} allcomp={props.allcomponent && props.allcomponent} />
      <Footer />
      <FooterSM/>
    </>
  );
}

export async function getStaticProps(context) {
  // the slug of the story
  let slug = "home"
  // the storyblok params
  let params = {
    version: "draft", // or 'published' / ' draft
  }

  // checks if Next.js is in preview mode
  if (context.preview) {
    // loads the draft version
    params.version = "draft"
    // appends the cache version to get the latest content
    params.cv = Date.now()
  }

  let newstory = await Storyblok.get(`cdn/stories/privacy-policy`,params);

  let allnewstory=newstory.data.story.content.body;
  let allcomp=newstory.data.story.content;
//   console.log("privact ");
  // return the story from Storyblok and whether preview mode is active
  return {
    props: {
      privacy: allnewstory,
      allcomponent:allcomp,
      preview: context.preview || false
    },
    revalidate: 10,
  }
}

